module.exports = __webpack_public_path__ + "img/whatsapp-new.64c7b04c.svg";